import { z } from 'zod';

export const positionDtoSchema = z.object({
  coordinates: z.array(z.number()).length(2),
  properties: z.object({
    name: z.string(),
    address: z.string(),
    city: z.string().optional(),
    countryCode: z.string().optional(),
  }),
});

export type PositionDto = z.infer<typeof positionDtoSchema>;
